module.exports = __webpack_public_path__ + "media/images/pic/smiling-kids-e348deb719096b43a071777608077fe8.jpeg";